import App from './App';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { lazy } from 'react';

/* Render MFE application root element */
const MFE_ROOT_ID = 'rental-web-components-root';
const mfeElement = document.getElementById(MFE_ROOT_ID) as HTMLElement;
if (!mfeElement) {
  const newRootElement = document.createElement('div');
  newRootElement.id = MFE_ROOT_ID;
  document.body.appendChild(newRootElement);
  const root = ReactDOM.createRoot(newRootElement);
  const Main = lazy(() => import('./renderer/Main'));
  root.render(<Main />);
}

/* Render App root element */
const rootElement = document.getElementById('esr-root') as HTMLElement;
if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(<App />);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
